import React, { useEffect, useState } from 'react'
import useApp from 'hooks/useApp'
import { Button, LayerBottom } from 'components'
import carImg from 'images/tmp_car_image.png'
import stamp from 'images/tmp_stamp.png'
import styles from './index.module.css'

const DataDetailOthers = () => {

	const App = useApp()
	const [showLayer, setShowLayer] = useState(false)
	const [tabList, setTabList] = useState(0)
	const [dataOpen, setDataOpen] = useState()

	const openLayer = () => {
		setShowLayer(true)
	}

	const closeLayer = () => {
		setShowLayer(false)
	}

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="shadow">
				<div className="padding flex-justify_between">
					<h4>김모니님의<br /><strong>데이터 증명서</strong></h4>
					<span style={{ color: "#999", fontWeight: 500 }}>일련번호 No. 1511515151555898</span>
				</div>
			</div>

			{/* 신용정보 */}
			<div className="shadow">
				<div className={`${dataOpen === 0 ? "active" : ""} accordion-title flex-justify_between align_center padding`} onClick={() => setDataOpen(0)}>
					<h3>신용정보</h3>
					<i className="icon icon_accordion_arrow" />
				</div>
				<div className="accordion-content padding pt_0">
					<p className={styles["info-title"]}>
						김모니님의 점수는 <strong className="text-blue">923점</strong>으로<br />
						<strong>상위 21%</strong>에 있네요!
					</p>

					{/* 그래프 영역 */}
					<div className="mt_50" style={{ width: "22rem", height: "16.2rem", background: "#f5f5f5", margin: "0 auto" }}></div>

					<hr className="my_40" />
					<p className={`${styles["info-sub-title"]} mt_40`}>
						30대 남성 평균 보다 김모니님의<br />점수가 <strong className="text-blue">50점 더 높아요!</strong>
					</p>

					<div className="mt_30 pb_50 progress-wrap">
						<span className="flex-shrink_0">30대 남성</span>
						<div className="data-progress flex--item_1 ml_15">
							<div className="progress" style={{ width: "80%" }}>
								<div className="txt">
									<span>나</span>
									<span>923점</span>
								</div>
							</div>
							<span className="floating-num" style={{ left: "70%" }}>평균 873점</span>
						</div>
					</div>
				</div>
			</div>

			{/* 소득정보 */}
			<div className="shadow">
				<div className={`${dataOpen === 1 ? "active" : ""} accordion-title flex-justify_between align_center padding`} onClick={() => setDataOpen(1)}>
					<h3>소득정보</h3>
					<i className="icon icon_accordion_arrow" />
				</div>
				<div className="accordion-content padding pt_0">
					<p className={styles["info-title"]}>직장정보</p>
					<ul className={`${styles["job-info"]} mt_20`}>
						<li className={styles.title}>
							<span>주식회사 핀테크</span>
							<span className="text-blue">1년 10개월</span>
						</li>
						<li>
							<span>2021.01.01 ~</span>
							<span>재직중</span>
						</li>
					</ul>
					<hr className="my_40" />
					<p className={styles["info-title"]}>올해 소득은 작년대비<br /><strong className="text-blue">10% 상승</strong>했어요!</p>
					<div className="mt_20" style={{ color: "#666" }}>최근 3년동안 소득 <strong>인상률 평균은 5%</strong>에요.<br />
						* 평균 3,000만원</div>
					{/* 그래프 영역 */}
					<div className="mt_30" style={{ margin: "0 2rem", height: "17.2rem", background: "#f5f5f5" }}></div>
				</div>
			</div>

			{/* 마이데이터 */}
			<div className="shadow">
				<div className={`${dataOpen === 2 ? "active" : ""} accordion-title flex-justify_between align_center padding`} onClick={() => setDataOpen(2)}>
					<h3>마이데이터</h3>
					<i className="icon icon_accordion_arrow" />
				</div>
				<div className="accordion-content">
					<ul className="tab-scroll no-scroll">
						<li onClick={() => setTabList(0)} className={tabList === 0 ? "active" : ""}>은행</li>
						<li onClick={() => setTabList(1)} className={tabList === 1 ? "active" : ""}>카드</li>
						<li onClick={() => setTabList(2)} className={tabList === 2 ? "active" : ""}>보험</li>
						<li onClick={() => setTabList(3)} className={tabList === 3 ? "active" : ""}>증권</li>
						<li onClick={() => setTabList(4)} className={tabList === 4 ? "active" : ""}>전자금융</li>
						<li onClick={() => setTabList(5)} className={tabList === 5 ? "active" : ""}>통신</li>
						<li onClick={() => setTabList(6)} className={tabList === 6 ? "active" : ""}>개인IRP</li>
					</ul>
					<ul className={`${styles["mydata-list"]} padding`}>
						<li>
							<span>계좌 잔액</span>
							<span className={styles.price}><strong className="text-blue mr_5">54,000,000</strong>원</span>
						</li>
						<li>
							<span>남은 대출금</span>
							<span className={styles.price}><strong className="text-blue mr_5">1,200,000,000</strong>원</span>
						</li>
						<li>
							<span>투자평가금액</span>
							<span className={styles.price}><strong className="text-blue mr_5">14,325,020</strong>원</span>
						</li>
					</ul>
				</div>
			</div>

			{/* 자동차 */}
			<div className="shadow">
				<div className={`${dataOpen === 3 ? "active" : ""} accordion-title flex-justify_between align_center padding`} onClick={() => setDataOpen(3)}>
					<h3>자동차</h3>
					<i className="icon icon_accordion_arrow" />
				</div>
				<div className="accordion-content padding pt_0">
					<p className={styles["info-title"]}>차량정보</p>
					<div className="slider mt_40">
						<ul>
							<li>
								<div className="img-box mt_40" style={{ width: "30rem", height: "13.6rem", margin: "0 auto" }}>
									<img src={carImg} alt="" />
								</div>
								<span className="license-plate mt_35">245 무 1245</span>
								<div className="car-info mt_20">
									<div>
										<span>테슬라</span>
										<span>테슬라 모델X</span>
									</div>
									<p>조대리님 미래 2058년의 차 테슬라 모델X</p>
								</div>
								<div className="car-price mt_10"><strong className="text-blue">13,800</strong> 만원</div>
								<ul className="my-info-box mt_30">
									<li>
										<span>미납</span>
										<span className="text-red">통행료 미납</span>
									</li>
									<li>
										<span>보험</span>
										<span className="text-red">만기 D-30</span>
									</li>
									<li>
										<span>검사</span>
										<span style={{ color: "#333" }}>만기 D-123</span>
									</li>
								</ul>
							</li>
						</ul>
						<ul className="slider-dots dots-gray" style={{ position: "absolute", right: 0, top: "-6rem" }}>
							<li className="active" />
							<li />
							<li />
						</ul>
					</div>
				</div>
			</div>

			{/* 집 */}
			<div className="shadow">
				<div className={`${dataOpen === 4 ? "active" : ""} accordion-title padding`} onClick={() => setDataOpen(4)}>
					<div className="flex-justify_between align_center">
						<h3>집</h3>
						<i className="icon icon_accordion_arrow" />
					</div>
				</div>
				<div className="accordion-content">
					<p className={`${styles["info-title"]} padding pt_0 pb_0`}>부동산 정보</p>
					<ul className="estate-list list-bg pb_40">
						<li>
							<p>에이치스퀘어 N차</p>
							<div className="flex-justify_between align_center">
								<div className="estate-info">
									<span>오피스텔</span>
									<span>매매</span>
								</div>
								<strong>7억 4,000만원</strong>
							</div>
						</li>
						<li>
							<p>에이치스퀘어 N차</p>
							<div className="flex-justify_between align_center">
								<div className="estate-info">
									<span>오피스텔</span>
									<span>매매</span>
								</div>
								<strong>1,230만원</strong>
							</div>
						</li>
					</ul>
				</div>
			</div>

			<div className="padding">
				<p style={{ fontSize: "1.6rem" }}>이 증명서는 원본 내용과 틀림없음을 증명합니다.</p>
				<div className="flex-justify_end align_center mt_40">
					<p style={{ color: "#666" }}>2021.12.06<br />주식회사 핀테크(모니)</p>
					<div className="img-box ml_20" style={{ width: "7.4rem", height: "7.4rem" }}>
						<img src={stamp} alt="" />
					</div>
				</div>
			</div>

			<TermsLayer show={showLayer} closeLayer={closeLayer} closeButton={false} />
		</div>
	)
}

const TermsLayer = ({ show, closeLayer, closeButton }) => {
	return (
		<LayerBottom show={show} closeLayer={closeLayer} closeButton={closeButton} outside={
			<Button className="btn btn--big btn-layer" onClick={closeLayer}>확인</Button>
		}>
			<div>
				<div className="chk">
					<input type="checkbox" id="check1" name="agree" />
					<label htmlFor="check1">
						<span><strong>[필수]</strong> 정보 공유 동의</span>
					</label>
				</div>
				<div className="layer-text mt_30">
					<p>
						공유 서비스는 개인이 본인의 정보를 직접 선택하여 공유하고자 하는 사람에게 제공하는 서비스 이며, 이에 관한 관리 책임은 이용자 본인에게 있어요.
					</p>
					<p className="mt_20">
						서비스 이용상의 과실 또는 제 3자에 의한 부정사용 등으로 인해 발생하는 모든 불이익에 대해 회사는 이에 책임을 지지 않아요. 다만, 회사의 고의 또는 과실에 의한 경우는 제외되어요.
					</p>
				</div>
			</div>
		</LayerBottom>
	)
}

export default DataDetailOthers
